import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
import { useSelector, useDispatch } from "react-redux";
import ServiceImageAdd from "./ServiceImageAdd";
import ServiceImageEdit from "./ServiceImageEdit";
import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper/modules";
import { delServiceImageInfo } from "../../../redux/slices/mainDataSlice";
export default function ServiceInfo({
  serviceInfo,
  serviceInfoId,
  serviceInfoClinc,
  setServiceInfo,
}) {
  const data = useSelector(
    (state) => state.main.data?.servicesImagesData
  )?.filter(
    (item) =>
      item.service_id == serviceInfoId && item.clinc_id == serviceInfoClinc
  );
  const [serviceEdit, setServiceEdit] = useState(false);
  const [serviceAdd, setServiceAdd] = useState(false);
  const [serviceInfoImgId, setServiceInfoImgId] = useState(false);
  const isMobile = /iPhone|Android/i.test(navigator.userAgent);

  const handlerEditService = (id) => {
    setServiceEdit(true);
    setServiceInfoImgId(`${id}`);
  };
  const dispatch = useDispatch();
  return (
    serviceInfo === true && (
      <>
        <div className="service-info-admin" data-aos="fade-in">
          <div
            className="content-layout"
            onClick={() => setServiceInfo(false)}
          ></div>
          <div className="add-icon" onClick={() => setServiceAdd(true)}>
            <lord-icon
              src="https://cdn.lordicon.com/jgnvfzqg.json"
              trigger="hover"
              className="img"
              style={{ width: "50px", height: "50px" }}
            ></lord-icon>
          </div>
          {isMobile ? (
            <Swiper
              effect={"cards"}
              grabCursor={true}
              modules={[EffectCards]}
              className="container "
            >
              <div className="add-icon" onClick={() => setServiceAdd(true)}>
                <lord-icon
                  src="https://cdn.lordicon.com/jgnvfzqg.json"
                  trigger="hover"
                  className="img"
                  style={{ width: "50px", height: "50px" }}
                ></lord-icon>
              </div>
              {data?.map((section) => (
                <SwiperSlide className="section">
                  <div className={isMobile ? "image active" : "image"}>
                    <img
                      src={`https://api.atharalfarasha.com/public/hakim/${section?.service_image}`}
                      alt=""
                    />
                  </div>
                  <div
                    className="edit-icon"
                    onClick={() => handlerEditService(section?.id)}
                  >
                    <img src="/images/edit-text.png" alt="" />
                  </div>
                  <div className={isMobile ? "data active" : "data"}>
                    <div className="layout"></div>
                    <div className="title">
                      <span>تفاصيل عن الحالة</span>
                    </div>
                    <div className="desc">{section?.service_desc}</div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <Swiper
              pagination={{
                dynamicBullets: true,
              }}
              slidesPerView={"auto"}
              centeredSlides={true}
              spaceBetween={20}
              modules={[Pagination]}
              className="container "
            >
              {data?.map((section) => (
                <SwiperSlide className="section">
                  <div className={isMobile ? "image active" : "image"}>
                    <img
                      src={`https://api.atharalfarasha.com/public/hakim/${section?.service_image}`}
                      alt=""
                    />
                  </div>{" "}
                  <div
                    className="del-icon"
                    onClick={() => dispatch(delServiceImageInfo(section?.id))}
                  >
                    <lord-icon
                      src="https://cdn.lordicon.com/skkahier.json"
                      trigger="hover"
                      className="img"
                      style={{ width: "50px", height: "50px" }}
                    ></lord-icon>
                  </div>
                  <div
                    className="edit-icon"
                    onClick={() => handlerEditService(section?.id)}
                  >
                    <img src="/images/edit-text.png" alt="" />
                  </div>
                  <div className={isMobile ? "data active" : "data"}>
                    <div className="layout"></div>
                    <div className="title">
                      <span>تفاصيل عن الحالة</span>
                    </div>
                    <div className="desc">{section?.service_desc}</div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
          :<></>
        </div>
        <ServiceImageAdd
          serviceAdd={serviceAdd}
          serviceInfoId={serviceInfoId}
          setServiceAdd={setServiceAdd}
        />
        <ServiceImageEdit
          serviceEdit={serviceEdit}
          serviceInfoImgId={serviceInfoImgId}
          setServiceEdit={setServiceEdit}
        />
      </>
    )
  );
}
